import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getMediaAccounts(data) {
    return request.get(`/${platform}/media_accounts`, data)
}

export function deleteMediaAccounts(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/media_accounts/${ids}`)
}

export function storeOrUpdateMediaAccounts(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/media_accounts/${data.id}` : `/${platform}/media_accounts`;
    return request[method](url, data)
}
